/**
 * @generated SignedSource<<bcb00b72b0d5583cbb9553130291713e>>
 * @relayHash e71a775be71248f3cb49ccc2be7b37c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1fbccb3474bb76a8480c3dce8d82f8508178befb44a0a7c097e6f6c807407485

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CrossFlowTouchPointQuery$variables = {
  first: number;
  projectId: string;
};
export type CrossFlowTouchPointQuery$data = {
  readonly graphStore: {
    readonly projectAssociatedRepo: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "DevOpsRepository";
          readonly name: string | null | undefined;
          readonly providerId: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CrossFlowTouchPointQuery = {
  response: CrossFlowTouchPointQuery$data;
  variables: CrossFlowTouchPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CrossFlowTouchPointQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
            "kind": "LinkedField",
            "name": "projectAssociatedRepo",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "type": "DevOpsRepository"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CrossFlowTouchPointQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
            "kind": "LinkedField",
            "name": "projectAssociatedRepo",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/)
                        ],
                        "type": "DevOpsRepository"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1fbccb3474bb76a8480c3dce8d82f8508178befb44a0a7c097e6f6c807407485",
    "metadata": {},
    "name": "CrossFlowTouchPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fc042f56cf05f88d9ce61034fa17ab46";

export default node;
